import { useToastNotifications } from "--floponents-web/molecules/ToastNotification/ToastProvider";
import * as React from "react"
import { Body1 } from "--components/typography";
import styled from "styled-components";
import { Button } from "--floponents-web/atoms/Button";

const toastId = "canary-upgrade-notify"
const reloadDuration = 10 * 60 * 1000;

const versionCheckPeriod = Math.floor((35 + Math.random() * 30)) * 60 * 1000; //check every 45 min to 75 min for a version change
const StyledToast = styled.div`
    display: flex;
    flex-direction: column;
    align-items:start;
    gap: ${p => p.theme.spacing(1)};
`
export const CanaryNotify: React.FC<{ at: number }> = props => {
    const timeRemaining = Math.floor((props.at - Date.now()) / 1000);
    const [_, setV] = React.useState(0);
    const mins = Math.floor(timeRemaining / 60);
    const secs = timeRemaining - 60 * mins;
    const timeRemainingFormatting = `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
    React.useEffect(() => {
        const interval = setInterval(() => {
            setV(v => v + 1)
        }, 1000);
        return () => {
            clearInterval(interval);
        }
    }, [])
    return <StyledToast>
        <Body1>
            A new version of the application is available and will be loaded soon.
        </Body1>
        <div>
            <Button onClick={() => window.location.reload()}>
                Load now -&nbsp;{timeRemainingFormatting}
            </Button>
        </div>
    </StyledToast>
}

export const useVersionCanary = () => {
    const notify = useToastNotifications();
    React.useEffect(() => {
        const fn = async () => {
            try {
                const res = await fetch(window.$$CANARY_LOC)
                if (res.status == 404) {
                    notify.addToast(<CanaryNotify at={Date.now() + reloadDuration} />, { id: toastId, appearance: "info", autoDismiss: false })
                    console.log("useVersionCanary yielded a 404 - version change.")
                    setTimeout(() => window.location.reload(), reloadDuration);
                }
            } catch (e) {
                console.error(e);
            }
        }
        const interval = setInterval(fn, versionCheckPeriod)
        fn();
        return () => { clearInterval(interval) }
    }, [])
}